import { create } from "zustand";
import type { SnackbarMessage } from "../components/StatusSnackbar";

/**
 * App-wide fallback error surface for React Query mutations.
 *
 * Fed exclusively by the `MutationCache.onError` handler in
 * `TenantQueryClientProvider.tsx`'s `createQueryClient()` — that handler is
 * plain (non-React) code, so it reaches the UI through this store rather than
 * component state. A mutation-local `onError` is detected automatically;
 * callers that surface an error elsewhere opt out via
 * `meta: { suppressGlobalError: true }`. Every otherwise-unhandled mutation
 * failure lands here so nothing fails completely silently.
 *
 * Rendered once at the app root by `GlobalErrorSnackbar`.
 */
interface GlobalErrorSnackbarState {
    snack: SnackbarMessage | null;
    showError: (message: string) => void;
    clear: () => void;
}

export const useGlobalErrorSnackbarStore = create<GlobalErrorSnackbarState>()((set) => ({
    snack: null,
    showError: (message) => set({ snack: { color: "danger", message } }),
    clear: () => set({ snack: null }),
}));
